import React from 'react'
import {withPopupToggles, withToggles} from 'startlibs/lib/hocs'
import {Errors, Form, withForm, TextInput} from 'startlibs/lib/form'
import {Dialog, Button, DraggableContainer, DraggableItem, Icon, Link, Tooltip} from 'startlibs/lib/components'
import {Fill} from 'react-slot-fill'
import {ice} from 'icepath'
import styled, {css} from 'styled-components'
import {SimpleErrors} from '../../components/SimpleErrors'
import {addReportKeyImage} from 'report-components/src/reducers'
import {getColor} from 'startlibs/lib/lib'
import {getKeyImageNameOrPlaceholder} from '../../lib'
import {darken} from 'polished'

const autoSaveType = {type: 'keyImages'}

const KeyImageBox = styled.div`
  background-color: white;
  background-image: ${props => props.backgroundImage};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 5px;
  cursor: pointer;
  :after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border: 1px solid rgba(0,0,0,0.2);
    border-radius: 5px;
    pointer-events: none;
  }
  .key-image-thumbnail-label {
    position: absolute;
    bottom: 0;
    padding: 0.5rem 0.5rem;
    background-color: rgba(0,0,0,0.75);
    width: 100%;
    color: white;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  :hover {
    .key-image-thumbnail-label {
      white-space: normal
    }
  }
  ${props => props.loading && css`
    background: ${getColor('gray30')};
    .loader-container {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  `}
`

const KeyImagePreview = styled.div` {
  margin: auto;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-color: black;
  background-image: url("${props => props.backgroundImage}");
  ${props => props.fullSize ? `
    height: ${props.height}px;
    width: ${props.width}px;
    cursor: move;
    ${props.grabbing ? `cursor: grabbing;` : `cursor: grab`}
    ` : `
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  `}
}`

const KeyImageContainer = styled.div`
  overflow: auto;
  flex-grow: 1;
  position: relative;
  background: black;
  display: flex;
  flex-direction: column;
  :after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    border-bottom: 1px solid rgba(0,0,0,0.2);
    pointer-events: none;
  }
`

const UpgradeHeadingText = styled.div`
  color: rgba(0, 0, 0, 0.6);
  cursor: default;
  padding: 0.5rem;
  margin: -0.75rem -0.75rem -0.75rem 0;
  display: flex;
  align-items: center;
  ${Icon} {
    font-size: 16px;
    margin-right: .25rem;
    color: ${getColor('gray180')};
  }
`

const UpgradeHeadingLink = styled(Link)`
  margin-left: auto;
  display: flex;
  align-items: center;
  text-decoration: none;
  font-weight: 600;
  color: ${getColor('main')};
  ${Icon} {
    font-size: 24px;
    margin-right: .5rem;
  }
  &:hover {
    color: ${props => (darken(0.075, getColor('main')(props)))};
  }
`

const DragAndDropArea = styled.div`
  &.placeholder-drag-area {
    span.horos-content {
      flex-direction: column;
      &.upgrade-needed {
        background: rgba(0, 0, 0, 0.05);
        border: 1px solid rgba(0,0,0,0.15);
      }
      p {
        margin: 0;
        &.main-text {
          font-weight: 600;
          font-size: 14px;
        }
      }
    }
  }
`
const KeyImageDetails = styled.div`
  label {
    margin-bottom: 1rem;
  }
`

const UploadKeyImageButton = styled.div`
  position: relative;
`
const ZoomImageButton = styled(Dialog.CloseIcon)`
  top: 5.25rem;
  font-size: 31px;
`
const KeyImageDialog = styled(Dialog)`
  max-width: 48rem;
  height: 100%;
  max-height: 70rem;
  padding: 0;
  @media (min-height: 720px) {
    max-width: 53rem;
  }
  @media (min-height: 780px) {
    max-width: 58rem;
  }
  .dialog-content {
    padding-top: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
    border-radius: 6px;
    overflow: hidden;
    width: auto;
    border-top-left-radius: 6px;
  }
  .key-image-details {
    padding: 2rem;
    background-color: #fff;
    width: 100%;
    .details-heading {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: justify;
          -ms-flex-pack: justify;
              justify-content: space-between;
      -ms-flex-wrap: wrap;
          flex-wrap: wrap;
      -webkit-box-align: center;
          -ms-flex-align: center;
              align-items: center;
      h3 {
        margin: 0;
        margin-right: 2rem;
        font-weight: bold;
        max-width: 60%;
      }
    }
    .description-box {
      margin-top: 1rem;
    }
    .key-image-footer {
      text-align: right;
    }
  }
  .prev-dialog-button, .next-dialog-button {
    color: white;
    text-shadow: 0 0 5px rgba(0,0,0,0.5);
    font-size: 60px;
    z-index: 10;
    cursor: pointer;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    padding: 0.5rem 2rem;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    :hover {
      text-shadow: 0 0 7px rgba(0,0,0,0.75);
    }
  }
  .prev-dialog-button {
    left: -6rem;
  }
  .next-dialog-button {
    right: -6rem;
    top: 50%;
    transform: translateY(-50%);
  }
  ${Dialog.CloseIcon} {
    background: white;
    text-shadow: none;
    color: rgba(0,0,0,0.6);
    width: 3.25rem;
    height: 3.25rem;
    line-height: 3.25rem;
    box-shadow: 0 1px 2px 0px rgba(0,0,0,0.3), 0 0px 6px -1px rgba(0,0,0,0.4);
    :hover {
      background: #e6e6e6;
    }
  }
  @media (min-width: 795px) {
    ${Dialog.CloseIcon} {
      top: 0;
      right: -4rem;
    }
    ${ZoomImageButton} {
      top: 4.25rem;
    }
  }
`

const ReleaseBetaTag = styled.span`
  border: 1px solid ${getColor('main')};
  padding: 3px 0.25rem;
  line-height: 1;
  border-radius: 3px;
  color: ${getColor('main')};
  font-size: 11px;
  margin-top: -1px;
  text-decoration: none;
  margin-left: 0.5rem;
`

const getBackgroundImage = (keyImage, getResource) => keyImage.file ? `url("${URL.createObjectURL(keyImage.file)}")` : `url("${getResource(keyImage.resourceUID)}")`

@withToggles('previewKeyImage')
export class KeyImages extends React.Component {
  state = {itemSlice: 0}

  cancel = (keyImage) => {
    this.props.remove(keyImage.id)
  }

  undoTimer = -1

  remove = (keyImage) => {
    this.setState({deletedKeyImage: keyImage})
    this.undoTimer = setTimeout(() => {
      this.confirmDeleteKeyImage(keyImage)
      if (this.state.deletedKeyImage === keyImage)
        this.setState({deletedKeyImage: null})
    }, 5000)
    const updatedKeyImage = ice(keyImage)
      .set('deleted', true)
      .value()
    this.props.update(updatedKeyImage)
  }

  confirmDeleteKeyImage = (keyImage) => {
    this.props.deleteResource(keyImage.resourceUID).then(() => {
      this.props.remove(keyImage.id)
    })
  }

  undoDelete = () => {
    window.clearTimeout(this.undoTimer)
    const updatedKeyImage = ice(this.state.deletedKeyImage)
      .unset('deleted')
      .value()
    this.props.update(updatedKeyImage)
    this.setState({deletedKeyImage: null})
  }

  setItemOrder = (from, to) => {
    const oldOrder = this.props.reportKeyImages.map(_ => _.id)
    const itemSlice = this.state.itemSlice
    const newOrder = ice(oldOrder).splice(from + itemSlice, 1).splice(to + itemSlice, 0, oldOrder[from + itemSlice]).value()
    this.props.updateOrder(newOrder)
  }

  setDragRef = (el) => {
    if (el) {
      el.addEventListener('dragover', this.handleDrag)
      el.addEventListener('dragenter', this.handleDrag)
    }
  }

  handleDrag = (e) => {
    if (this.props.needsUpgrade) return
    e.preventDefault()
    e.stopPropagation()
    e.dataTransfer.dropEffect = 'copy'
    this.setState({isDragging: true})
  }

  handleDragLeave = (e) => {
    if (e.target === e.currentTarget)
      this.setState({isDragging: false})
  }

  handleDrop = (e) => {
    e.preventDefault()
    e.stopPropagation()

    const {setErrors} = this.props
    this.props.clearErrors()
    const files = (e.dataTransfer || e.nativeEvent.target).files
    if (files.length > 0) {
      const {validated, errors} = Array.prototype.slice.call(files).reduce((acc, file) =>
          ['image/gif', 'image/png', 'image/jpeg', 'image/jpg', ' image/bmp'].indexOf(file.type.toLowerCase()) < 0 ?
          ice.pushIn(acc, 'errors', file.name + ' is not supported. Only .JPG, .PNG, .BMP and .GIF files are supported.') :
          file.size > 8388608 ? ice.pushIn(acc, 'errors', file.name + ' is larger than 8MB. Key images must be smaller than 8MB.') :
          ice.pushIn(acc, 'validated', file)
        , {validated: [], errors: []})

      if (errors.length) {
        setErrors(errors.reduce((acc, error) => ({...acc, [Date.now()]: [error]}), {}))
      }
      if (validated.length && this.props.openCompactPanel) {
        this.props.openCompactPanel()
      }
      validated.forEach((file, i) => {
          const image = document.createElement('img')
          image.onload = () => {
            const {naturalWidth: imageWidth, naturalHeight: imageHeight} = image
            this.props.addNew({
              file,
              id: this.props.newId + i,
              uploadStatus: 'uploading',
              description: '',
              name: '',
              imageWidth,
              imageHeight
            }, this.props.reportKeyImages.length)
          }
          image.src = URL.createObjectURL(file)
        }
      )
    }
    e.target.value = null
    this.setState({isDragging: false})
  }

  prevPreviewImage = () => {
    const allKeyImages = this.props.reportKeyImages
    const savedKeyImages = allKeyImages.filter(_ => !_.uploadStatus)
    const totalImages = savedKeyImages.length
    const keyImage = savedKeyImages[(savedKeyImages.indexOf(allKeyImages[this.props.previewKeyImage.isOpen]) + totalImages - 1) % totalImages]
    this.props.previewKeyImage.open(allKeyImages.indexOf(keyImage))
  }

  nextPreviewImage = () => {
    const allKeyImages = this.props.reportKeyImages
    const savedKeyImages = allKeyImages.filter(_ => !_.uploadStatus)
    const totalImages = savedKeyImages.length
    const keyImage = savedKeyImages[(savedKeyImages.indexOf(allKeyImages[this.props.previewKeyImage.isOpen]) + 1) % totalImages]
    this.props.previewKeyImage.open(allKeyImages.indexOf(keyImage))
  }

  getCompactErrors = () => {
    const errors = (this.props.errors || {})
    const quant = Object.keys(errors).length
    if (!quant) return {}

    return {
      files: [<span>{quant === 1 ? 'File' : (quant + ' Files were')} too large or in invalid format for uploading - <a
        onClick={this.props.scrollToErrors}>View Details</a></span>]
    }
  }

  setLastItemRef = (e) => {
    if (this.props.reportKeyImages.length === 1)
      this.firstItemElement = e
    this.lastItemElement = e
  }
  setFirstItemRef = (e) => this.firstItemElement = e

  moveLeft = () => this.setState(({itemSlice}) => ({itemSlice: itemSlice - 1}))
  moveRight = () => this.setState(({itemSlice}) => ({itemSlice: itemSlice + 1}))
  moveToLast = () => {
    const countSameRow = (el) => {
      return (el.nextSibling && el.nextSibling.getBoundingClientRect().top === el.getBoundingClientRect().top) ?
             countSameRow(el.nextSibling) + 1 : 1
    }
    const n = countSameRow(this.firstItemElement.parentNode)
    const totalImages = this.props.reportKeyImages.length
    if (totalImages > n) {
      this.setState({itemSlice: totalImages - n})
    }
  }


  componentDidUpdate(prevProps) {
    const newUploadStatus = this.props.reportKeyImages.slice(-1).map(_ => _.uploadStatus)[0]
    if (this.props.isPanel && prevProps.reportKeyImages.slice(-1).map(_ => _.uploadStatus)[0] !== newUploadStatus && newUploadStatus === 'uploading') {
      this.moveToLast()
    }
    this.updateArrows()
  }

  componentDidMount() {
    window.addEventListener('scroll', this.updateArrows)
    window.addEventListener('beforeunload', this.preventWindowLeave)
    this.updateArrows()
    if (!this.props.isPlaceholder) {
      this.props.deletedReportKeyImages.forEach((keyImage) => this.confirmDeleteKeyImage(keyImage))
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.updateArrows)
    window.removeEventListener('beforeunload', this.preventWindowLeave)
  }

  preventWindowLeave = (e) => {
    if (this.props.reportKeyImages.filter(_ => _.uploadStatus === 'uploading').length) {
      const confirmationMessage = 'You have unsaved Key Images.'
      e.returnValue = confirmationMessage     // Gecko, Trident, Chrome 34+
      return confirmationMessage              // Gecko, WebKit, Chrome <34
    }
  }

  updateArrows = () => {
    if (!this.props.isPanel) {
      if (this.state.itemSlice || this.state.arrowRight || this.state.arrowLeft) {
        this.setState({itemSlice: 0, arrowLeft: false, arrowRight: false})
      }
      return
    }
    if (!this.lastItemElement || !this.firstItemElement) return
    const arrowRight = this.lastItemElement.getBoundingClientRect().top !== this.firstItemElement.getBoundingClientRect().top
    const arrowLeft = this.state.itemSlice !== 0
    if (this.state.arrowRight !== arrowRight || this.state.arrowLeft !== arrowLeft) {
      this.setState({arrowRight, arrowLeft})
    }
  }

  preventClick = (e) => e.stopPropagation()

  render() {
    const {
      reportKeyImages,
      needsUpgrade,
      isReleaseTrial,
      isHorosCloud,
      deleteResource,
      isPanel,
      isPlaceholder,
      reportUID,
      getResource,
      uploadFetcher,
      toggleCompactPanel,
      previewKeyImage,
      update,
      clearErrors,
      errors,
      retryFailed
    } = this.props
    const {deletedKeyImage, itemSlice, arrowRight, arrowLeft, isDragging} = this.state
    const failed = reportKeyImages.filter(_ => _.uploadStatus === 'failed')
    const savedKeyImages = reportKeyImages.filter(_ => !_.uploadStatus)
    const imageClass = isDragging ? ' dragging' : ''
    return (
      <div>
        <div className="report-key-images-header" onClick={toggleCompactPanel || undefined}>
          <label><span className="field-label images-heading">Key images</span></label> {isReleaseTrial &&
        <ReleaseBetaTag>Beta</ReleaseBetaTag>}
          {
            failed.length === 1 &&
            <div className="failed-uploads-warning" onClick={this.preventClick}><span
              className="icon icon-failure"/>{failed.length} failed upload
              - <a className="link" onClick={retryFailed}>Retry</a></div>
          }
          {
            failed.length > 1 &&
            <div className="failed-uploads-warning" onClick={this.preventClick}><span
              className="icon icon-failure"/>{failed.length} failed uploads
              - <a className="link" onClick={retryFailed}>Retry all</a></div>
          }
          {reportKeyImages.length > 0 && needsUpgrade &&
          <UpgradeHeadingText><Icon icon="failure"/> Only users in the Report plus plan are allowed to use key
            images.</UpgradeHeadingText>}
          {needsUpgrade ?
           <UpgradeHeadingLink as="span"><Icon icon="premium"/> Key images require the Report plus plan</UpgradeHeadingLink> :
           <UploadKeyImageButton onClick={this.preventClick} className="button small-button highlight with-icon"
                                 key="upload-key-image">
             <span className="icon icon-upload"/>
             Upload image files
             <input multiple type="file" onChange={this.handleDrop}/>
           </UploadKeyImageButton>
          }
        </div>
        <div
          className={'report-key-images' + imageClass}
          ref={this.setDragRef}
          onDragLeave={this.handleDragLeave}
          onDrop={this.handleDrop}
        >
          {isDragging &&
          <div className="drop-zone">Drop your files here to upload them</div>
          }
          {
            reportKeyImages.length > 0 ?
            <div>
              {arrowLeft && <a className="navigation-arrow icon icon-arrow-left-line" onClick={this.moveLeft}/>}
              <DraggableContainer
                className="drag-drop-limits"
                scrollOnDrag={!isPanel}
                setItemOrder={this.setItemOrder}
              >
                {reportKeyImages.slice(itemSlice).map((keyImage, i) =>
                  <KeyImage
                    needsUpgrade={needsUpgrade}
                    slicedIndex={i}
                    index={i + itemSlice}
                    key={keyImage.id}
                    keyImage={keyImage}
                    reportUID={reportUID}
                    update={update}
                    uploadFetcher={uploadFetcher}
                    getResource={getResource}
                    remove={this.remove}
                    isPlaceholder={isPlaceholder}
                    innerRef={(i === reportKeyImages.length - 1 - itemSlice) ?
                              this.setLastItemRef :
                              i === 0 ? this.setFirstItemRef : undefined
                    }
                    cancel={this.cancel}
                    openPreview={() => previewKeyImage.open(i + itemSlice)}
                    deleteResource={deleteResource}
                  />).concat([])
                }
              </DraggableContainer>
              {arrowRight && <a className="navigation-arrow icon icon-arrow-right-line" onClick={this.moveRight}/>}
            </div>
                                       :
            (
              needsUpgrade ?
              <DragAndDropArea className="placeholder-drag-area">
                    <span className="upgrade-needed horos-content">
                      <p className="main-text">Key Images uploading and editing is only supported in the Report plus plan.</p>
                      </span>
              </DragAndDropArea> :
              <DragAndDropArea className="placeholder-drag-area">
                {isHorosCloud ?
                 <span className="horos-content">
                        <p
                          className="main-text">Open Horos and define an image in the study as key image via the app.</p>
                        <p>You can also manually drag and drop your image files here to upload them.</p>
                      </span> :
                 <span>Drag and drop your image files here to upload them.</span>
                }
              </DragAndDropArea>
            )
          }
          {
            isPanel ?
            <SimpleErrors action={addReportKeyImage} errors={this.getCompactErrors()}/> :
            <SimpleErrors action={addReportKeyImage} errors={errors}/>
          }
          {
            typeof previewKeyImage.isOpen === 'number' &&
            <EditReportKeyImageDialog
              formProperties={reportKeyImages[previewKeyImage.isOpen]}
              keyImage={reportKeyImages[previewKeyImage.isOpen]}
              save={update}
              needsUpgrade={needsUpgrade}
              getResource={getResource}
              index={previewKeyImage.isOpen}
              next={savedKeyImages.length > 1 && this.nextPreviewImage}
              prev={savedKeyImages.length > 1 && this.prevPreviewImage}
              closeDialog={previewKeyImage.close}
            />
          }
          {
            deletedKeyImage &&
            <Fill name="Notifications">
              <div className="system-notification undo-notification">Key Image successfully deleted
                <a className="button small-button" onClick={this.undoDelete}>Undo</a>
              </div>
            </Fill>
          }
        </div>
      </div>
    )
  }
}


@withPopupToggles('contextMenu')
@withToggles('editDialog')
class KeyImage extends React.Component {

  constructor(props) {
    super(props)
    const keyImage = props.keyImage
    this.state = {backgroundImage: getBackgroundImage(keyImage, props.getResource)}
  }

  componentDidMount() {
    if (this.props.keyImage.uploadStatus === 'uploading') {
      this.startUpload()
    }
    if (this.props.keyImage.uploadStatus === undefined) {
      this.setState({imageLoading: true}, this.loadImage)
    }
  }

  componentWillReceiveProps(newProps) {
    if (this.props.keyImage.uploadStatus === 'failed' && newProps.keyImage.uploadStatus === 'uploading') {
      this.startUpload()
    }
    if (this.props.keyImage.uploadStatus === 'uploading' && newProps.keyImage.uploadStatus === undefined) {
      this.setState({backgroundImage: getBackgroundImage(newProps.keyImage, newProps.getResource)})
    }
  }

  loadImage = () => {
    const finish = () => this.setState({imageLoading: false})
    const img = document.createElement('img')
    img.onload = finish
    img.onerror = finish
    img.src = this.props.getResource(this.props.keyImage.resourceUID)
  }

  retryUpload = () => {
    this.props.update(ice.set(this.props.keyImage, 'uploadStatus', 'uploading'))
  }

  cancel = () => {
    this.canceled = true
    this.props.cancel(this.props.keyImage)
  }

  remove = () => this.props.remove(this.props.keyImage)

  startUpload = () => {
    if (this.props.isPlaceholder) return

    const {keyImage, update, uploadFetcher, reportUID} = this.props
    const file = keyImage.file
    const formData = new FormData()
    formData.append('file', file)
    uploadFetcher(formData, reportUID)
      .then(({errors, success}) => {
        if (this.canceled && success && success.keyImage) {
          this.props.deleteResource(success.keyImage)
          return
        }
        if (errors) {
          update(ice.set(keyImage, 'uploadStatus', 'failed'))
        } else {

          const updatedKeyImage = ice(keyImage)
            .set('resourceUID', success.keyImage)
            .unset('uploadStatus')
            .unset('file')
            .value()
          update(updatedKeyImage)
        }
      }).catch(e => {
      update(ice.set(keyImage, 'uploadStatus', 'failed'))
    })
  }

  render() {
    const {contextMenu, needsUpgrade, innerRef, getResource, keyImage, openPreview, slicedIndex, index, editDialog, update} = this.props
    const {backgroundImage, imageLoading} = this.state
    const {uploadStatus} = keyImage
    return (
      <DraggableItem
        id={keyImage.id}
        index={slicedIndex}
        className={status}
        ghostScale={1.03}
        onClick={uploadStatus ? undefined : openPreview}
      >
        <KeyImageBox
          innerRef={innerRef}
          className="key-image-box"
          backgroundImage={backgroundImage}
          loading={imageLoading}
          status={uploadStatus}
        >
          {
            imageLoading &&
            <div className="loader-container">
              <div className="loader light-colors"/>
            </div>
          }
          {
            uploadStatus === 'uploading' &&
            <div className="upload-status">
              <div className="loader light-colors"/>
              <button type="button" className="action-button small-button" onClick={this.cancel}>Cancel</button>
            </div>
          }
          {
            uploadStatus === 'failed' &&
            <div className="upload-status">
              <div className="failed-upload">
                <span className="icon icon-failure"/>
                Upload failed
              </div>
              <button type="button" className="alert action-button small-button" onClick={this.retryUpload}>Retry
              </button>
            </div>
          }
          {
            uploadStatus === 'failed' ?
            <button
              data-drag={false}
              type="button"
              className="small-button only-icon edit-button"
              onClick={this.cancel}
            >
              <span className="icon icon-x"/>
            </button>
                                      : (!uploadStatus && !needsUpgrade &&
              <a
                data-drag={false}
                className="button small-button only-icon edit-button dropdown"
                onClick={contextMenu.toggle}
              />)
          }
          {
            contextMenu.isOpen &&
            <ul onClick={e => e.stopPropagation() || contextMenu.toggle()} data-drag={false} className="context-menu">
              <li onClick={editDialog.open}><a><span className="icon icon-edit-box"/>Edit description</a></li>
              <li onClick={this.remove}><a><span className="icon icon-delete"/>Delete image</a></li>
            </ul>
          }
          {
            !uploadStatus &&
            <div className="key-image-thumbnail-label">{getKeyImageNameOrPlaceholder(keyImage, index)}</div>
          }
          {
            editDialog.isOpen &&
            <EditReportKeyImageDialog
              getResource={getResource}
              keyImage={keyImage}
              formProperties={keyImage}
              save={update}
              index={index}
              needsUpgrade={needsUpgrade}
              editingIsOpen={true}
              closeDialog={editDialog.close}
            />
          }
        </KeyImageBox>
      </DraggableItem>
    )
  }
}

@withForm()
@withToggles('editing', 'confirmDialog', 'zoom', 'grabbing')
class EditReportKeyImageDialog extends React.Component {

  onSuccess = () => {
    this.props.confirmDialog.close()
    this.props.editing.close()
  }

  confirmCloseDialog = () => {
    if (this.props.form.hasChanged) {
      this.props.confirmDialog.toggle()
    } else {
      this.props.closeDialog()
    }
  }

  scrolling

  startScrollOnDrag = (ev) => {
    ev.preventDefault()
    ev.stopPropagation()
    this.props.grabbing.open()
    window.addEventListener('mousemove', this.scrollOnDrag)
    window.addEventListener('mouseup', this.endScrollOnDrag)
    const el = ev.currentTarget.offsetParent
    this.scrolling = {
      el,
      startX: ev.clientX + el.scrollLeft,
      startY: ev.clientY + el.scrollTop
    }
  }

  endScrollOnDrag = () => {
    this.props.grabbing.close()
    window.removeEventListener('mousemove', this.scrollOnDrag)
    window.removeEventListener('mouseup', this.endScrollOnDrag)
  }

  scrollOnDrag = (ev) => {
    const deltaX = this.scrolling.startX - ev.clientX
    const deltaY = this.scrolling.startY - ev.clientY
    this.scrolling.el.scroll(deltaX, deltaY)
  }

  setValueWithMaxLength = (maxLength) => (value,path,setter) => {
    if (value.length > maxLength) {
      this.props.setErrors(ice.set({},path,[`Maximum number of characters has been exceeded, the limit is ${maxLength}.`]))
    }
    setter(value.slice(0,maxLength))
  }

  render() {
    const {editing, zoom, grabbing, form, next, save, prev, needsUpgrade, closeDialog, getResource, confirmDialog, keyImage, index} = this.props
    return (
      <KeyImageDialog
        confirm={form.connector.handleSubmit}
        next={!editing.isOpen && next}
        prev={!editing.isOpen && prev}
        closeDialog={this.confirmCloseDialog}
        withImageHeader
      >
        <ZoomImageButton onClick={zoom.toggle} icon={zoom.isOpen ? 'zoom-out' : 'zoom-in'}/>
        <Dialog.Content className="dialog-content">
          <Form form={form} handleSubmit={save} onSuccess={this.onSuccess}/>
          <KeyImageContainer>
            <KeyImagePreview
              onMouseDown={zoom.isOpen ? this.startScrollOnDrag : undefined}
              height={keyImage.imageHeight}
              width={keyImage.imageWidth}
              backgroundImage={getResource(keyImage.resourceUID)}
              fullSize={zoom.isOpen}
              grabbing={grabbing.isOpen}
            />
          </KeyImageContainer>
          {
            editing.isOpen ?
            <KeyImageDetails className="key-image-details">
              <TextInput
                label="Name"
                path="name"
                form={form}
                setValue={this.setValueWithMaxLength(32)}
                placeholder={getKeyImageNameOrPlaceholder({name: form.properties.name}, index)}
              />
              <TextInput
                label="Description"
                path="description"
                form={form}
                setValue={this.setValueWithMaxLength(600)}
                textarea
              />
              <div className="key-image-footer">
                <Button onClick={editing.isOpen ? editing.close : closeDialog}>Cancel</Button>
                <Button isLoading={form.isLoading} onClick={form.connector.handleSubmit}>Save</Button>
                <Button highlight isLoading={form.isLoading}
                        onClick={() => form.connector.handleSubmit().then(({errors}) => !errors && closeDialog())}>Save
                  & Close</Button>
              </div>
              <Errors form={form}/>
            </KeyImageDetails>
                           :
            <div className="key-image-details viewing">
              <div className="details-heading">
                <h3>{getKeyImageNameOrPlaceholder(keyImage, index)}</h3>
                <div>
                  {
                    needsUpgrade ?
                    <UpgradeHeadingLink as="span"><Icon icon="premium"/> Key images require the Report plus plan</UpgradeHeadingLink> :
                    <Button icon="edit-box" onClick={editing.open}>
                      Edit description
                    </Button>
                  }

                </div>
              </div>
              {
                keyImage.description &&
                <div className="box description-box">{keyImage.description}</div>
              }
            </div>
          }
        </Dialog.Content>
        {
          confirmDialog.isOpen &&
          <Fill name="Confirm-Dialog">
            <Dialog
              title="Your changes won't be saved"
              closeDialog={confirmDialog.toggle}
            >
              <Dialog.Content>
                The changes made on this screen were not saved. Would you like to quit anyway?
              </Dialog.Content>
              <Dialog.Footer>
                <Button onClick={confirmDialog.toggle}>Cancel</Button>
                <Button onClick={() => form.connector.handleSubmit().then(({errors}) => !errors && closeDialog())}
                        isLoading={form.isLoading} type="submit">Save change</Button>
                <Button alert onClick={closeDialog}>Discard changes</Button>
              </Dialog.Footer>
            </Dialog>
          </Fill>
        }
        {
          !editing.isOpen && prev &&
          <div className="prev-dialog-button" onClick={prev}><span className="icon icon-arrow-left-line"/></div>
        }
        {
          !editing.isOpen && next &&
          <div className="next-dialog-button" onClick={next}><span className="icon icon-arrow-right-line"/></div>
        }
      </KeyImageDialog>
    )
  }
}



// WEBPACK FOOTER //
// ./~/report-components/src/modules/editor/KeyImages.jsx